import { render } from "./COIPagination.vue?vue&type=template&id=c9a2a858"
import script from "./COIPagination.vue?vue&type=script&lang=js"
export * from "./COIPagination.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__